import { TTintService } from 'features/product-info/components/pdp-select-tint-color';

type TProps = {
  services: (TTintService | never)[];
  newTintService: {
    serviceIdForTint: string;
    hex: string;
    parentLineId: string;
    color: string;
  };
  newQuantity: number;
};

export const getServicesWithNewTintService = ({ services, newTintService, newQuantity }: TProps) => {
  const { serviceIdForTint, hex, parentLineId, color } = newTintService;

  return [
    ...services,
    {
      id: parseInt(serviceIdForTint),
      quantity: newQuantity,
      parentLineId: parentLineId,
      parameters: {
        color: color,
      },
      hex: hex,
    },
  ];
};
